import { createContext, useContext, useEffect, useState } from 'react'

import { BelongItemList } from '@/modules/belongs/domain/models/BelongItemList'
import { BelongItemStatus } from '@/modules/belongs/domain/models/BelongItemStatus'
import { BelongStatus } from '@/modules/belongs/domain/models/BelongStatus'
import { categorizeItemsByStatus } from '@/modules/belongs/domain/models/CategorizeItemsByStatus'
import { filterItemsByStatus } from '@/modules/belongs/domain/utils/FilterBelongByStatus'

import { useBelongItemsQuery } from '../hooks/useBelongItemsQuery'

export type CategorizedItems = {
  READY_TO_USE: BelongItemList
  PENDING: BelongItemList
  LOST: BelongItemList
  DAMAGED: BelongItemList
}

const belongsItemsContext = createContext<{
  belongItems: BelongItemList
  status: BelongItemStatus
  categorizedItems: CategorizedItems
  isError: boolean
  isLoading: boolean

  setBelongItems: (data: BelongItemList) => void
  filterBelongs: (filter: BelongItemStatus) => void
  setBelongItemsFilter: (data: BelongItemList) => void
  setStatus: (status: BelongItemStatus) => void
}>({
  belongItems: [],
  status: 'READY_TO_USE',
  categorizedItems: {
    READY_TO_USE: [],
    PENDING: [],
    LOST: [],
    DAMAGED: []
  },
  isError: false,
  isLoading: false,
  setBelongItems: () => {},
  filterBelongs: () => {},
  setBelongItemsFilter: () => {},
  setStatus: () => {}
})

export const useBelongsItemsContext = () => useContext(belongsItemsContext)

export default function BelongItemsProvider({
  children
}: {
  children: React.ReactNode
}) {
  const belongItemsQuery = useBelongItemsQuery()

  const [status, setStatus] = useState<BelongItemStatus>('ALL')

  const [belongItems, setBelongItems] = useState<BelongItemList>([])

  const categorizedItems = categorizeItemsByStatus(belongItemsQuery?.data)

  //TODO: Isso pode se resumir a apenas um estado
  function filterBelongs(filter: BelongStatus | 'ALL') {
    setStatus(filter as BelongStatus)
    if (filter === 'ALL') {
      setBelongItems(belongItemsQuery?.data || [])
    } else {
      setBelongItems(filterItemsByStatus(belongItemsQuery?.data, filter))
    }
  }

  useEffect(() => {
    filterBelongs(status)
  }, [belongItemsQuery.data])

  return (
    <belongsItemsContext.Provider
      value={{
        isError: belongItemsQuery.isSuccess,
        isLoading: belongItemsQuery.isPending,
        belongItems,
        status,
        categorizedItems,

        setBelongItems,
        filterBelongs,
        setBelongItemsFilter: () => {},
        setStatus
      }}
    >
      {children}
    </belongsItemsContext.Provider>
  )
}
